var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showMoqMessage())?_c('a-tag',{staticClass:"moq-message"},[_vm._v(" MOQ "+_vm._s(_vm.moq)+" Available ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }